import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { DEVICE_TYPE } from '../../config/devices';
import { INewApartmentForm } from '../../containers/DeviceModal/components/NewApartmentForm/validationSchema';
import { useSiteContext } from '../../context/useSiteContext';
import { isAnsweringUnit } from '../../helpers/devices';
import { selectors as apartmentsSelectors } from '../../modules/apartments';
import { renderApartmentMenuItems } from '../ApartmentMenuItems/ApartmentMenuItems';
import messages from './messages';

const menuItemSx = { lineHeight: '22px' };

export interface ISetApartmentFormFieldProps {
  deviceType?: string;
  disabled: boolean;
}

export function SetApartmentFormField({ deviceType, disabled }: ISetApartmentFormFieldProps) {
  const apartments = useSelector(apartmentsSelectors.getApartmentsListGrouped);
  const isBillingTypeApartment = useSiteContext().hasSiteBillingType('PER_APARTMENT');
  const { setValue, trigger, watch } = useFormContext<INewApartmentForm>();
  const value = watch('apartmentId');

  const isNoApartmentDisabled =
    isBillingTypeApartment &&
    (isAnsweringUnit(deviceType) || deviceType === DEVICE_TYPE.THIRD_PARTY || deviceType === DEVICE_TYPE.HIPMO);

  function onChangeApartment(e: React.ChangeEvent<HTMLInputElement>) {
    const newValue = parseInt(e.target.value);
    setValue('apartmentId', newValue || undefined);
    trigger();
  }

  return (
    <Box sx={{ mt: 2 }}>
      <TextField
        disabled={disabled}
        fullWidth
        label={<FormattedMessage {...messages.apartmentLabel} />}
        margin="none"
        name="apartmentId"
        onChange={onChangeApartment}
        select
        slotProps={{
          select: {
            MenuProps: {
              anchorOrigin: {
                horizontal: 'center',
                vertical: 'bottom',
              },
            },
          },
        }}
        value={value || 0}
        variant="outlined"
      >
        <MenuItem disabled={isNoApartmentDisabled} key={0} sx={menuItemSx} value={0}>
          <FormattedMessage {...messages.apartmentEmptySelect} />
        </MenuItem>
        {renderApartmentMenuItems(apartments)}
      </TextField>
    </Box>
  );
}
